import * as React from 'react';
import styled, { keyframes } from "styled-components";

const SpinnerKeyFrames = keyframes` 
    to { -webkit-transform: rotate(360deg); }`;

export const Spinner = styled.div`
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(0,0,0,.3);
    border-radius: 50%;
    border-top-color: #fff;
    margin-top: 400px;
    animation: ${SpinnerKeyFrames} 1s ease-in-out infinite;`;

const SpinnerWrapper = styled.div<{isLoading:boolean}>`
    position: fixed;
    top:0px;
    right:0px;
    width:100%;
    height:100%;
    display:flex;
    background: #333;
    justify-content: center;
    
    z-index:10000000;
    visibility: ${props => props.isLoading ? 'visible' : 'hidden'};
    opacity: ${ props => props.isLoading  ? '0.5' : '0'};
    transition: all 500ms linear;`;

type LoadingPageOverlayProps = { loading:boolean };

export function LoadingPageOverlay({loading}:LoadingPageOverlayProps):JSX.Element {

        
        function bodyHasScrollbar() {
            return document.body.scrollHeight > window.innerHeight;
          }
    
        React.useEffect(() => {
            if (loading && bodyHasScrollbar()) {
                document.body.classList.add('loading-open-scroll');
                document.body.classList.remove('loading-open-no-scroll');
            } else if(loading && !bodyHasScrollbar()) {
                document.body.classList.add('loading-open-no-scroll');
                document.body.classList.remove('loading-open-scroll');
            } 
            
            return () => {
                document.body.classList.remove('loading-open-scroll');
                document.body.classList.remove('loading-open-no-scroll');
            };
            
          }, [loading]);


    return(
        <SpinnerWrapper isLoading={loading}>
            <Spinner />
        </SpinnerWrapper>
    );
}